'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.MagicConfigMixin = exports.setCurrencyMultipliers = exports.setPaths = exports.translationExists = exports.translate = exports.setWallet = exports.setUiBackgroundConfig = exports.setRouteGetter = exports.setLanguage = exports.updateInterpolationParams = exports.setInterpolationParams = exports.setDesktop = exports.setTablet = exports.setMobile = exports.addTranslations = exports.setTranslations = exports.magicConfig = exports.ThumbnailType = void 0;
var tslib_1 = require("tslib");
var vue_1 = tslib_1.__importDefault(require("vue"));
var index_1 = require("../routing/index");
var vue_class_component_1 = tslib_1.__importDefault(require("vue-class-component"));
var util_1 = require("../util");
var link_1 = tslib_1.__importDefault(require("../routing/link"));
var parts_util_1 = require("./utils/parts.util");
var ThumbnailType;
(function (ThumbnailType) {
    ThumbnailType["SEARCH"] = "search";
    ThumbnailType["HOME"] = "home";
    ThumbnailType["MAIN_PROMOTION"] = "mainPromotion";
    ThumbnailType["ENTERTAINING_PROMOTION"] = "entertainingPromotion";
    ThumbnailType["EXCLUSIVE_PROMOTION"] = "exclusivePromotion";
    ThumbnailType["LAST_PLAYED"] = "lastPlayed";
    ThumbnailType["REWARD_MODAL"] = "rewardModal";
    ThumbnailType["PROMOTION_GAMES"] = "promotionGames";
    ThumbnailType["FREE_TO_PLAY"] = "freeToPlay";
    ThumbnailType["FREE_TO_PLAY_MAX"] = "freeToPlayMax";
    ThumbnailType["SQUARE"] = "square";
})(ThumbnailType = exports.ThumbnailType || (exports.ThumbnailType = {}));
exports.magicConfig = {
    mobile: false,
    tablet: false,
    desktop: false,
};
function generateSetter(name) {
    return function (value) {
        if (exports.magicConfig.hasOwnProperty(name)) {
            exports.magicConfig[name] = value;
        }
        else {
            vue_1.default.set(exports.magicConfig, name, value);
        }
    };
}
exports.setTranslations = generateSetter('translations');
function addTranslations(translations) {
    if (exports.magicConfig.hasOwnProperty('translations')) {
        exports.magicConfig.translations = tslib_1.__assign(tslib_1.__assign({}, exports.magicConfig.translations), translations);
    }
    else {
        vue_1.default.set(exports.magicConfig, 'translations', translations);
    }
}
exports.addTranslations = addTranslations;
exports.setMobile = generateSetter('mobile');
exports.setTablet = generateSetter('tablet');
exports.setDesktop = generateSetter('desktop');
exports.setInterpolationParams = generateSetter('interpolationParams');
/**
 * Adds/updates a given list of interpolation params
 *
 * @param params the param list
 */
function updateInterpolationParams(params) {
    exports.setInterpolationParams(tslib_1.__assign(tslib_1.__assign({}, exports.magicConfig.interpolationParams), params));
}
exports.updateInterpolationParams = updateInterpolationParams;
exports.setLanguage = generateSetter('language');
exports.setRouteGetter = generateSetter('getRoute');
exports.setUiBackgroundConfig = generateSetter('uiBackgroundConfig');
exports.setWallet = generateSetter('wallet');
function translate(key, params) {
    // We use magicConfig instead of this.magicConfig to be able to
    // use $t to initialise class properties, e.g.
    // `public title = $t('foo.title')`.
    // Otherwise an error is raised and multiple weird errors start appearing
    if (!exports.magicConfig.translations) {
        console.warn('Wand translation error: translations obj is empty');
        return '';
    }
    if (!exports.magicConfig.translations.hasOwnProperty(key)) {
        return '';
    }
    var interpolateParams = exports.magicConfig.interpolationParams;
    if (params) {
        interpolateParams = tslib_1.__assign(tslib_1.__assign({}, interpolateParams), params);
    }
    return util_1.interpolate(exports.magicConfig.translations[key] || '', interpolateParams);
}
exports.translate = translate;
function translationExists(key) {
    if (!exports.magicConfig.translations) {
        console.warn('Wand translation error: translations obj is empty');
        return false;
    }
    return exports.magicConfig.translations.hasOwnProperty(key);
}
exports.translationExists = translationExists;
exports.setPaths = generateSetter('paths');
exports.setCurrencyMultipliers = generateSetter('currencyMultipliers');
var MagicConfigMixin = /** @class */ (function (_super) {
    tslib_1.__extends(MagicConfigMixin, _super);
    function MagicConfigMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.magicConfig = exports.magicConfig;
        _this.RoutablePage = index_1.RoutablePage;
        return _this;
    }
    MagicConfigMixin.prototype.beforeCreate = function () {
        this.$t = translate;
        this.$p = parts_util_1.partsBinder;
    };
    MagicConfigMixin.prototype.routeTo = function (link) {
        return this.magicConfig.getRoute(link).go();
    };
    MagicConfigMixin.prototype.getHref = function (link) {
        return this.magicConfig.getRoute(link).href;
    };
    MagicConfigMixin.prototype.getFullHref = function (link) {
        return window.location.origin + this.magicConfig.getRoute(link).href;
    };
    MagicConfigMixin.prototype.isRouteActive = function (link) {
        var currRoute = this.magicConfig.getRoute(link);
        return currRoute.isActive ? currRoute.isActive() : false;
    };
    Object.defineProperty(MagicConfigMixin.prototype, "$filteredAttrs", {
        /**
         * Filters out data-v and style attributes so when web components
         * are used as root components they do not pass down their host
         * style attribute.
         * @readonly
         */
        get: function () {
            return Object.entries(this.$attrs)
                .filter(function (_a) {
                var key = _a[0];
                return !key.startsWith('data-v') && key !== 'style';
            })
                .reduce(function (prev, _a) {
                var key = _a[0], value = _a[1];
                prev[key] = value;
                return prev;
            }, {});
        },
        enumerable: false,
        configurable: true
    });
    MagicConfigMixin = tslib_1.__decorate([
        vue_class_component_1.default({
            inheritAttrs: false,
            components: {
                'magic-router-link': link_1.default,
            },
            filters: {
                translate: translate,
            },
        })
    ], MagicConfigMixin);
    return MagicConfigMixin;
}(vue_1.default));
exports.MagicConfigMixin = MagicConfigMixin;
